import { useQuery } from '@apollo/client'
import { GET_COURSE_CONTENT } from './queries/getCourseContent'

interface IGetCourseContentProps {
  id: number
  courseId: number
  enrollmentId: number
  enabled?: boolean
}

export const useGetCourseContent = ({
  id,
  courseId,
  enrollmentId,
  enabled = true,
}: IGetCourseContentProps) => {
  const { data, loading, error } = useQuery(GET_COURSE_CONTENT, {
    variables: { id, courseId, enrollmentId },
    skip: !enabled,
    fetchPolicy: 'network-only',
  })

  return { data, loading, error }
}
